import { createContext, useContext, type ReactNode } from 'react';
import { DEFAULT_TIME_ZONE } from '@/shared/format/date';

const TimeZoneContext = createContext<string>(DEFAULT_TIME_ZONE);

/** Часовой пояс филиала для дат, времени и «сегодня» (ДАН-04, ПОРТ-11). */
export function TimeZoneProvider({ timeZone, children }: { timeZone: string; children: ReactNode }) {
  return <TimeZoneContext.Provider value={timeZone}>{children}</TimeZoneContext.Provider>;
}

export function useTimeZone(): string {
  return useContext(TimeZoneContext);
}
